module.exports = __webpack_public_path__ + "static/img/2_5_1.33a4bfdb.jpg";